import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default class {
    constructor() {
        const state = {
            loading: true,
            error: false,
            errorMessage: true,
            data: null,
            model: {
                match: 0,
                length: '',
                connector_right: '',
                connector_left: '',
                cable: '',
            },
            touched: false,
            submitTo: null,
            relatedLength: 0,
            configuration: null,
            cartkey: '',
        };

        const getters = {
            // application state
            loading: ({ loading }) => loading,
            error: ({ error }) => error,
            errorMessage: ({ errorMessage}) => errorMessage,
            ready: ({ loading, error }) => !loading && !error,

            // meta data
            header: ({ data }) => data.header,

            //endpoints
            submitTo: ({ submitTo }) => submitTo || '',

            //general getters
            productLookup: ({ data: { products } }) => (sku) => products.find(p => p.sku === sku),

            //configurator info
            model: ({ model }) => model,

            cart: ({ configuration }) => configuration.addToCart,
            productSheet: ({ configuration }) => configuration.productSheet,
            outOfStock: ({data }) => data.outOfStockMessage,
            touched: ({ touched }) => touched,
            products: ({ data }) => data.products,
            connectors: ({ data }) =>
                data.products.filter(p => p.category === 'connector'),
            cables: ({ data }) => data.products.filter(p => p.category === 'cable'),
            validity: ({ model, data: { products } }) => (product = false) => {
                const left = products.find(p => p.sku === model.connector_left);
                const right = products.find(p => p.sku === model.connector_right);
                const cable = products.find(p => p.sku === model.cable);
                const { length } = model;
                if (product) {
                    if (product.category === 'cable') {
                        if (left && right) {
                            return (
                                left.meta.compatibility.includes(product.sku) &&
                                right.meta.compatibility.includes(product.sku)
                            );
                        } else if (right) {
                            return right.meta.compatibility.includes(product.sku);
                        } else if (left) {
                            return left.meta.compatibility.includes(product.sku);
                        } else return true;
                    } else {
                        if (!cable) return true;
                        const connector = products.find(p => p.sku === product.sku);
                        return connector.meta.compatibility.includes(cable.sku);
                    }
                } else {
                    if (!left || !right || !cable || !length) return false;
                    return (
                        left.meta.compatibility.includes(cable.sku) &&
                        right.meta.compatibility.includes(cable.sku)
                    );
                }
            },
            configID: ({
                model: { connector_left, cable, connector_right },
            }) => {                
                let configID = `${connector_left}-${cable}-${connector_right}`;
                return configID;
            },


            //configuration data
            relatedLength: ({ relatedLength }) => relatedLength,
            configLookup: ({ data: { products } }) => configID => {
                let [left, cable, right, length] = configID.split('-');

                if (!left || !cable || !right || !length) return false;

                left = products.find(p => p.sku === left);
                cable = products.find(p => p.sku === cable);
                right = products.find(p => p.sku === right);
                length = String(length).split('');
                length.splice(length.length - 1, 0, '.');
                length = Number(length.join(''));

                if (!left || !cable || !right || !length) return false;

                return { left, cable, right, length };
            },

            //Mouser
            getMouserPartNumber: () => {
                return "523-IB086SMSMPF120IN";//testing item
            },

            buildMouserAddToCartJson: ( {getMouserPartNumber} ) => {
                let test = getMouserPartNumber;
                return test;
            }
            
        };

        const mutations = {
            assignStaticValues(state, data) {
                let entries = Object.entries(data);
                entries.forEach(([key, value]) => state[key] = value);
            },
            loadData(state, data) {
                state.data = data;
            },
            setLoading(state, value) {
                state.loading = value;
            },
            setErrorMessage(state, value) {
                state.errorMessage = value;
            },
            setError(state, value) {
                state.error = value;
            },
            setConfiguration(state, value) {
                state.configuration = value;
            },
            setModel(state, { parameter, value }) {
                if (parameter === 'cable') {
                    const left = this.getters.connectors.find(x => x.sku === state.model.connector_left);                
                    const right = this.getters.connectors.find(x => x.sku === state.model.connector_right);
                    const cable = this.getters.cables.find(x => x.sku === value);
    
                    const leftChild = !!left && !!cable 
                        ? left.children.find(x => x.meta.compatibility[0] === value) 
                        : undefined;
    
                    const rightChild = !!right && !!cable 
                        ? right.children.find(x => x.meta.compatibility[0] === value) 
                        : undefined;
    
                    const leftChildOutOfStock = !!leftChild 
                        ? left.meta.isOutOfStock || leftChild.meta.isOutOfStock
                        : false;
    
                    const rightChildOutOfStock = !!rightChild 
                        ? right.meta.isOutOfStock || rightChild.meta.isOutOfStock
                        : false;
    
                    // If a cable is selected where the individual connectors for that cable size are out of stock:
                    if (leftChildOutOfStock === true) {
                        alert(`${this.getters.outOfStock}: ${leftChild.name}`);
                        value = '';
                    } 
                    else if (rightChildOutOfStock === true) {
                        alert(`${this.getters.outOfStock}: ${rightChild.name}`);
                        value = '';
                    }
                }
                Vue.set(state.model, parameter, value);
            },
            setTouched(state) {
                state.touched = true;
            },
            clearModel(state) {
                state.touched = false;
                state.model = {
                    match: false,
                    length: '',
                    connector_right: '',
                    connector_left: '',
                    cable: '',
                };
            },
        };

        const actions = {
            fetchData({ commit }, source) {
                return fetch(source)
                    .then(response => {
                        if (response.ok) {
                            return response.json();
                        } else {
                            return false;
                        }
                    })
                    .then(data => {
                        if (data) {
                            commit('loadData', data);
                        } else {
                            commit('setError', true);
                        }
                    })
                    .catch(() => {
                        commit('setError', true);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            commit('setLoading', false);
                        }, 1250);
                    });
            },
        };

        this.store = new Vuex.Store({
            state,
            getters,
            mutations,
            actions,
        });
        return this;
    }
}